export default "__VITE_ASSET__XI8Ma5m$__"